// Kept in EXACT sync with the SLOW/NORMAL/FAST_SPEED_MULTIPLIER constants in
// app/models/chat.rb.
export const SPEED_MULTIPLIER = {
  slow: 0.78,
  normal: 0.92,
  fast: 1.16
};
